import { Tradeline } from 'handlers/applicationData';

export enum MethodCapability {
  PaymentsReceive = 'payments:receive',
  PaymentsSend = 'payments:send',
  DataRetrieve = 'data:retrieve',
  DataSync = 'data:sync',
}

export const isDirectPay = (methodCapabilities: Tradeline['methodCapabilities']) =>
  methodCapabilities?.some((m) => m === MethodCapability.PaymentsReceive);
